export default "__VITE_ASSET__ExdnD83f__"